import styled, { css, keyframes } from 'styled-components'

const animation = keyframes`
  0% {
    transform: scale(1);
  }

  25% {
    transform: scale(0.5);
  }

  50% {
    transform: scale(1.2);
  }

  100% {
    transform: scale(1);
  }
`

interface ContainerProps {
  isAdded?: boolean
  isLoading?: boolean
}

export const Container= styled.div<ContainerProps>`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    cursor: ${props => props.isLoading ? 'wait' : 'pointer'};
    width: 20px;
    height: 20px;
    stroke: ${props => !props.isAdded && props.theme.palette.general.greyDark};
    fill: ${props => props.isAdded && props.theme.palette.primary.alphaDark};
    transition: all 300ms ease;
    opacity: 1;
    transform: scale(1);
    ${props => props.isLoading && css`
      animation: 1.2s ease-in-out 0s infinite normal none running ${animation};
      stroke: transparent;
    `}

    &:hover,
    &:focus {
      fill: ${props => props.theme.palette.primary.alphaDark};
    }
  }

  span {
    margin-left: 4px;
  }
`
